import {React, useEffect} from 'react';
import { Link, useParams } from 'react-router-dom';
import Banner from "../Components/Banner";
import Industries_banner from "../images/banner_images/laptop/industries.png"
import IT from "../images/Industries/IT.png"
import Retail from "../images/Industries/Retail.png"
import Logistics from "../images/Industries/Logistics.png"
import commercial from "../images/Industries/Commercial.png"
import Development from "../images/Industries/Development.png"
import Energy from "../images/Industries/Energy.png"
import work from "../images/Industries/Why-work.png"
import service_img_1 from "../images/Industries/Ruppee.png"
import service_img_2 from "../images/Industries/Customers.png"
import service_img_3 from "../images/Industries/Creative.png"
import service_img_4 from "../images/Industries/Customer_relationship.png"
import service_img_5 from "../images/Industries/Online_access.png"
import trend_cardimage_1 from "../images/Insights/trend_cardimage_1.png"
import trend_cardimage_2 from "../images/Insights/trend_cardimage_2.png"
import trend_cardimage_3 from "../images/Insights/trend_cardimage_3.png"
import Milestones from "../Card-Components/milestones";
import AOS from 'aos';
import 'aos/dist/aos.css';


function Industries () {
    
   
    const Our_Services = [
        {
            heading:"Land Service",
            content:"Are you considering the purchase or sale of your land parcel? Or are you planning to aggregate land for your expansion? Our specialists can identify the optimal opportunity at the optimal time and location across multiple industries."
        },
        {
            heading:"Representation",
            content:"Our expertise includes tenant representation, acquisition/disposition, and landlord representation, and location advisory. Our solutions are curated with best-in-class consulting advice."
        },
        {
            heading:"Liaison Services",
            content:"Our comprehensive liaison services will facilitate the process of obtaining approvals and clearances from all government departments if you are purchasing, selling, developing, or leasing property in Tamil Nadu for residential development or industrial use."
        }
    ]

    const Service_Relationship =[
        {
            src : service_img_1,
            alt : "service",
            content :"Highly competitive rates, fees, and terms"
        },
        {
            src : service_img_2,
            alt : "service",
            content :"Direct access to decision makers,transparent and quicker deal making"
        },
        {
            src : service_img_3,
            alt : "service",
            content :"Flexible and creative approach"
        },
        {
            src : service_img_4,
            alt : "service",
            content :"Access to dedicated Relationship Manager"
        },
        {
            src : service_img_5,
            alt : "service",
            content :"Online access-visibility for progress"
        },
    ]

    const Insights =[
        {
            src:trend_cardimage_1,
            date:"june 15,2023",
            heading:"Lorem ipsum dolor sit amet consectetur. Tortor varius duis volutpat arcu a facilisi mauris feugiat elit.",
            content:"Lorem ipsum dolor sit amet consectetur. Tortor varius duis volutpat arcu a facilisi mauris feugiat elit. Lorem ipsum dolor sit amet consectetur. Tortor varius duis volutpat arcu a facilisi mauris feugiat elit.",
        },
        {
            src:trend_cardimage_2,
            date:"june 15,2023",
            heading:"Coimbatore Development Map",
            content:"Lorem ipsum dolor sit amet consectetur. Tortor varius duis volutpat arcu a facilisi mauris feugiat elit. Lorem ipsum dolor sit amet consectetur. Tortor varius duis volutpat arcu a facilisi mauris feugiat elit.",
        },
        {
            src:trend_cardimage_3,
            date:"june 15,2023",
            heading:"Lorem ipsum dolor sit amet consectetur. Tortor varius duis volutpat arcu.",
            content:"Lorem ipsum dolor sit amet consectetur. Tortor varius duis volutpat arcu a facilisi mauris feugiat elit. Lorem ipsum dolor sit amet consectetur.",
        },
    ]

    useEffect(()=>{
        AOS.init({duration:1000});
      }, []);

    return(
    <>

        <Banner 
            img={Industries_banner}
            heading={"Ground yourself on solid growth"}
            subheading={"Local Intel, Global impact"}
            button={"Explore our Services"}
            textposition={"w-[85%] bottom-8 left-8 right-8 lg:w-[675px] lg:bottom-[100px] lg:left-[100px]"}        
        />

        <div className="max-w-4xl mx-auto px-4 my-16 text-center">
            <h2 className="heading mt-6" data-aos="fade-up">Real<span className="font-[timesroman]" >-</span>estate services for Industry</h2>
            <p className="service-description" data-aos="fade-up" data-aos-duration="1100">Elevate your real estate strategy with local intelligence insights. Tailored to meet the unique needs of the industry, our innovative approach empowers you to make informed decisions, enhance property valuations, minimize risks, and optimize investments.</p>
        </div>


        {/* Industries served */}
        <div className="bg-[#F6F6F6] w-full mt-[78px] py-20 font-[lato] uppercase font-bold text-center px-2">
            <h2 className="subheading !capitalize" data-aos="fade-up">Industries Served</h2>

           <div className="max-w-4xl mx-auto grid grid-cols-1 gap-2 my-8 sm:my-[80px] sm:grid-cols-3 sm:gap-x-12 sm:gap-y-20">
                <Link to = "/industries/it">
                    <div className="industries_served shadow-xl mx-auto mt-10 sm:mt-0"data-aos="fade-up">
                        <img className="w-[85px] h-[85px] mx-auto mt-3" src={IT} alt="IT logo"/>
                        <h2 className="absolute bottom-12 inset-x-0">IT</h2>
                    </div>
                </Link>
                 <Link to = "/industries/retail">
                    <div className="industries_served shadow-xl mx-auto mt-10 sm:mt-0" data-aos="fade-up">
                        <img className="w-[85px] h-[72px] mx-auto mt-3" src={Retail} alt="Retail"/>
                        <h2 className="absolute bottom-12 inset-x-0">RETAIL</h2>
                    </div>
                 </Link>
                 <Link to = "/industries/logistics">
                    <div className="industries_served shadow-xl mx-auto mt-10 sm:mt-0"data-aos="fade-up">
                        <img className="w-[96px] h-[70px] mx-auto mt-3" src={Logistics} alt="Logistics"/>
                        <h2 className="absolute bottom-12 inset-x-0"> Logistics</h2>
                    </div>
                 </Link>
                 <Link to = "/industries/development">
                    <div className="industries_served shadow-xl mx-auto mt-10 sm:mt-0"data-aos="fade-up">
                        <img className="w-[102px] h-[80px] mx-auto mt-3" src={Development} alt="Development"/>
                        <h2 className="absolute bottom-12 inset-x-0">DEVELOPMENT</h2>
                    </div>
                 </Link>
                 <Link to ="/industries/commercial">
                    <div className="industries_served shadow-xl mx-auto mt-10 sm:mt-0"data-aos="fade-up">
                        <img className="w-[103px] h-[88px] mx-auto mt-3" src={commercial} alt="Commercial"/>
                        <h2 className="absolute bottom-12 inset-x-0">COMMERCIAL</h2>
                    </div>
                 </Link>
                 <Link to = "/industries/energy">
                    <div className="industries_served shadow-xl mx-auto mt-10 sm:mt-0"data-aos="fade-up">
                        <img className="w-[76px] h-[85px] mx-auto mt-3" src={Energy} alt="Energy"/>
                        <h2 className="absolute bottom-12 inset-x-0">ENERGY</h2>
                    </div>
                 </Link>
           </div>
        </div>

        {/* Service */}
        <div className="my-14 font-[lato] sm:my-28">
            <h2 className="subheading"data-aos="fade-up">Services</h2>

            <div className="max-w-6xl mx-auto my-2 py-4 flex flex-wrap justify-around lg:my-16" data-aos="fade-up">
                {
                    Our_Services.map((items) => {
                        return(
                            <div className="w-[334px] h-[387px] mt-10 p-8 border-2 border-[#E3E4E4] rounded-[8px] shadow-xl shadow-[#00000012] md:mt-16 lg:mt-0 transition ease-in-out duration-[650ms] hover:scale-[0.95] cursor-pointer">
                                <h2 className="font-bold text-[24px] tracking-[0.20px]">{items.heading}</h2>
                                <p className="mt-6 text-[#363537] text-[17.50px] font-400 leading-[27.50px] tracking-[0.50px]">{items.content}</p>
                            </div>
                        );
                    })
                }
            </div>
        </div>

        {/*Why Work With us ?  */}
        <div className="bg-yellow-50 w-full px-4 py-16 sm:px-6 lg:px-0 lg:py-28" data-aos="fade-up">
            <div className="max-w-6xl mx-auto ">
                <div className="bg-white w-fit px-4 py-2" data-aos="fade-up">
                    <p className="text-[22px]">Why work work with us ?</p>
                </div>
                <div className="mt-8 flex flex-col justify-between sm:mt-12 lg:flex-row lg:mt-20" data-aos="fade-up">
                    <div>
                        <h2 className="font-[lora] text-[#575857] font-medium text-[28px] sm:text-[35px] lg:text-[45px] lg:leading-[60px] lg:pr-8 ">Customer focus, technical interventions for property grading, and collaborative efforts with the industry's top intermediaries are what drive us towards our goal of providing fully personalized and relevant real estate solutions.</h2>
                    </div>
                    <img className="mx-auto mt-8 md:mt-16 lg:mt-0 sm:w-[504px] sm:h-[403px] " src={work} alt="work" />
                </div>
            </div>
        </div>
        
        {/* Service Relationship */}
        <div className="font-[lato] my-16 px-4 sm:my-28 ">
            <h2 className="subheading" data-aos="fade-up">Full service relationship </h2>

            <div className="max-w-6xl mx-auto my-10 flex flex-wrap justify-between sm:my-16" data-aos="fade-up">
                {
                    Service_Relationship.map((items) => {
                        return(
                            <div className="w-[190px] text-center mx-auto mt-8 sm:mt-0">
                                <img className="w-[86px] h-[86px] mx-auto my-6 sm:my-7" src={items.src} alt={items.alt} />
                                <p className="text-[#575857] text-[18px] font-medium leading-[26px] tracking-[0.40px] px-2">{items.content}</p>
                            </div>
                        );
                    })
                }
            </div>
        </div>
        
        {/* Milestones */}
        <Milestones />
        
        {/* Insights */}
        <div className="max-w-[1267px] mx-auto my-24 px-4">
            <h2 className="w-fit bg-[#F6F6F6] py-2.5 px-3.5 text-[26px]" data-aos="fade-up">Coimbatore Insights</h2>
            <h1 className="subheading !text-left mt-6 sm:mt-10" data-aos="fade-up">Industry corridors of Coimbatore</h1>
            <div className="flex justify-center flex-wrap my-4 lg:justify-between">
                {
                Insights.map((items) => {
                    return(
                        <div className="font-[lato] w-[399px] h-fit relative mt-10" data-aos="fade-up">
                            <img src={items.src} alt="cardimage"/>
                            <p className="text-font-grey text-[12px] uppercase py-2">{items.date}</p>
                            <h2 className="text-[20px] font-medium leading-[24px] py-1">{items.heading}</h2>
                            <p className="text-font-grey text-[14px] leading-[21px] mt-2 py-2">{items.content}</p>
                            {/* <div className="lg:absolute bottom-0">
                                <button className="bg-yellow text-[10.5px] uppercase tracking-[1px] mt-4 py-2 px-4 ">view more</button>
                            </div> */}
                        </div> 
                    );
                })}
            </div> 
        </div>   


    </>
    );
}

export default Industries